// extracted by mini-css-extract-plugin
export default {"wrap":"Logo_wrap__VDd1Z","image":"Logo_image__iYMpZ"};